export type Type = {
	searchTerm: string;
	selectionIndex: number;
	showSuggested: boolean;
};

export function create(): Type {
	return {
		searchTerm: '',
		selectionIndex: -1,
		showSuggested: false,
	};
}

export function setSearchTerm(state: Type, value: string): Type {
	return { ...state, searchTerm: value };
}

export function setSelectionIndex(state: Type, value: number): Type {
	return { ...state, selectionIndex: value };
}

export function setShowSuggested(state: Type, value: boolean): Type {
	return { ...state, showSuggested: value };
}

export function onChange(state: Type, value: string): Type {
	return { ...state, searchTerm: value, selectionIndex: -1, showSuggested: true };
}

export function onBlur(state: Type): Type {
	return { ...state, showSuggested: false, selectionIndex: -1 };
}

export function onFocus(state: Type): Type {
	return { ...state, showSuggested: true };
}
